module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "header",
    style: ({
      'background-image': 'url(' + this.bg + ')'
    })
  }, [_h('div', {
    staticClass: "h-content"
  }, [_h('div', {
    staticClass: "h-info"
  }, [_h('router-link', {
    staticClass: "logo",
    style: ({
      'background-image': 'url(' + this.logo + ')'
    }),
    attrs: {
      "to": {
        path: '/'
      }
    }
  }), " ", _h('a', {
    staticClass: "banner-title",
    attrs: {
      "href": url,
      "target": "_blank"
    }
  }, [_s(title)]), " ", _m(0)])]), " ", _h('div', {
    staticClass: "h-menu"
  }, [_h('div', {
    staticClass: "menu-wrapper"
  }, [_h('ul', [_h('li', {
    staticClass: "index-menu"
  }, [_h('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_m(1)])]), " ", _l((menus), function(menu) {
    return _h('li', {
      staticClass: "other-menu"
    }, [_h('router-link', {
      attrs: {
        "to": {
          path: menu.url
        }
      }
    }, [_h('div', {
      staticClass: "menu-num"
    }, [_h('span', {
      staticClass: "num"
    }, [_s(menu.num)])]), " ", _h('span', {
      staticClass: "menu-text"
    }, [_s(menu.text)])]), " ", _h('smallMenu', {
      attrs: {
        "items": menu.items
      }
    })])
  }), " ", _h('li', {
    staticClass: "last-menu"
  }, [_h('router-link', {
    staticClass: "square",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_m(2)]), " ", _m(3)]), " ", _h('li', {
    staticClass: "last-menu"
  }, [_h('router-link', {
    staticClass: "live",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_m(4)]), " ", _h('smallMenu', {
    attrs: {
      "items": onlines
    }
  })]), " ", _m(5)]), " ", _m(6)])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "search"
  }, [_h('a', {
    staticClass: "link-ranking",
    attrs: {
      "href": "http://www.bilibili.com/ranking",
      "target": "_blank"
    }
  }, [_h('span', ["排行榜"])]), " ", _h('form', [_h('input', {
    attrs: {
      "type": "text",
      "name": "search",
      "autocomplete": "off",
      "placeholder": "如何在MC中还原《三体》原著"
    }
  }), " ", _h('button', {
    attrs: {
      "type": "button"
    }
  })])])
}},function (){with(this) {
  return _h('span', {
    staticClass: "menu-text"
  }, ["首页"])
}},function (){with(this) {
  return _h('span', ["广场"])
}},function (){with(this) {
  return _h('div', {
    staticClass: "second-menu"
  }, [_h('ul', [_h('li', [_h('a', {
    attrs: {
      "href": "http://activity.bilibili.com",
      "target": "_blank"
    }
  }, [_h('i', {
    staticClass: "i-activity"
  }), " ", _h('b', ["活动中心"])])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "http://game.bilibili.com",
      "target": "_blank"
    }
  }, [_h('i', {
    staticClass: "i-game"
  }), " ", _h('b', ["游戏中心"])])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "http://h.bilibili.com",
      "target": "_blank"
    }
  }, [_h('i', {
    staticClass: "i-h"
  }), " ", _h('b', ["画友"])])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "http://www.bilibili.com/mango",
      "target": "_blank"
    }
  }, [_h('i', {
    staticClass: "i-m"
  }), " ", _h('b', ["芒果TV"])])])]), " ", _h('div', {
    staticClass: "s-right"
  }, [_h('div', {
    staticClass: "item"
  }, [_h('a', {
    attrs: {
      "href": "http://www.bilibili.com/event",
      "target": "_blank"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/group1/M00/B7/C6/oYYBAFefJyWAdVAcAAD9KmVEAFw381.jpg"
    }
  })])])])])
}},function (){with(this) {
  return _h('span', ["直播"])
}},function (){with(this) {
  return _h('li', {
    staticClass: "last-menu"
  }, [_h('a', {
    staticClass: "black-house",
    attrs: {
      "href": "//www.bilibili.com/blackroom",
      "target": "_blank"
    }
  }, [_h('span', ["小黑屋"])])])
}},function (){with(this) {
  return _h('div', {
    staticClass: "right-menu"
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/icon/575cd42b00dbd63236116cb56ae44641.gif",
      "alt": "动起来"
    }
  })])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/template-compiler.js?id=data-v-6!./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/selector.js?type=template&index=0!./src/components/BgNav.vue
 ** module id = 37
 ** module chunks = 2
 **/